import { EditButton, TopToolbar, useGetIdentity, useRedirect } from 'react-admin'

const TextModelShowActions = () => {
  
  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()
  if(isLoading || !identity) return null

  return (
    <TopToolbar>
      <EditButton onClick={(e) => {
        e.preventDefault()
        redirect(`/users/${identity.id}/textModel/edit`)
      }}/>
    </TopToolbar>
  )
}

export default TextModelShowActions